// src/helpers/qcEmail.js
// Hook para enviar correo cuando el caller (GridPage) le pase SOLO los "nuevos" Ready for QC.
// - GridPage calcula cuáles son nuevos (baseline: localStorage qcKnownReady) y aquí solo enviamos.
// - Envía solo por Job ID con valor (no vacío).
// - Envía automáticamente (sin confirmación).

import { useEffect } from "react";

/**
 * Envia email (backend) para una fila.
 * @param {object} row
 * @param {import('axios').AxiosInstance} Axios
 */
async function sendReadyQcEmail(row, Axios) {
  try {
    await Axios.post("/notify_ready_qc.php", {
      jobid: row?.jobid || "",
      jobsta: row?.jobsta || "",
      jobuser: row?.jobuser || "",
      jobti: row?.jobti || "",
      jobpro: row?.jobpro || "",
      proname: row?.proname || "",
      jobdatesub: row?.jobdatesub || "",
    });
  } catch (e) {
    console.error("Email QC error:", e?.response?.data || e?.message || e);
  }
}

/**
 * @param {Array<object>} qcList filas completas (con jobid, jobsta, etc.) SOLO de los NUEVOS Ready for QC
 * @param {import('axios').AxiosInstance} Axios instancia configurada
 */
export function useReadyQcEmail(qcList, Axios) {
  useEffect(() => {
    if (!Array.isArray(qcList) || qcList.length === 0) return;

    // Normaliza filas con Job ID válido
    const rows = qcList
      .map((r) => ({ ...(r || {}), jobid: String(r?.jobid ?? "").trim() }))
      .filter((r) => r.jobid !== "");

    if (rows.length === 0) return;

    rows.forEach((r) => {
      sendReadyQcEmail(r, Axios);
    });
  }, [qcList, Axios]);
}
